import styled from "styled-components";
import {makeStyles} from "@material-ui/core/styles";
import Background from "../../assets/login/background.jpg";
import BackgroundSGP from "../../assets/login/background_sgp.jpg";
import {lgDown, smDown} from "../../ui/common";
import QnectButton from "../qnect-ui/qnect-button";
import SwipeableViews from "react-swipeable-views";
import SearchIcon from '../../assets/Search.svg';
import ArrowDownIcon from '../../assets/Unfold.svg';
import ArrowUpIcon from '../../assets/Fold.svg';
import EditIcon from '../../assets/Edit.svg';
import DeleteIcon from '../../assets/Delete.svg';
import PagingLeftFullIcon from '../../assets/PagingLeftFull.svg';
import PagingLeftIcon from '../../assets/PagingLeft.svg';
import PagingRightFullIcon from '../../assets/PagingRightFull.svg';
import PagingRightIcon from '../../assets/PagingRight.svg';

export const StyledTopBackground = styled.div`
  height: 460px;
  width: 100%;
  background-image: ${({country}) => country === 'SGP' ? 'url(' + BackgroundSGP +')' : 'url(' + Background +')'};
  background-size: cover;
  background-position: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  ${lgDown`
    height: 245px;
  `}
  ${smDown`
    height: 165px;
  `}
`;

export const HeaderWrapper = styled.div`
  margin: 0 auto;
  width: 100%;
  max-width: 1110px;
  height: 100%;
  position: relative;
`;

export const StyledMiddleBackground = styled.div`
  background-color: #f6f8fa;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 64px;
  ${lgDown`
    padding: 0 0 40px 24px;
  `}
  ${smDown`
    padding: 60px 0 40px 16px;
  `}
`;

export const StyledBottomBackground = styled(StyledMiddleBackground)`
  background-color: white;
  height: 803px;
  ${lgDown`
    height: 100%;
    min-height: 611px;
    padding-bottom: 40px;
  `}
  ${smDown`
    padding: 0 0 40px 16px;
    min-height: 520px;
  `}
`;

export const StyledInfoBox = styled.div`
  height: 182px;
  width: 1111px;
  border-radius: 20px;
  background-color: rgba(255, 255, 255, 0.8);
  box-shadow: 0 0 60px 0 rgba(0, 0, 0, 0.06);
  margin: 146px 0 164px;
  display: flex;
  justify-content: space-between;
  ${lgDown`
    width: 646px;
    height: 120px;  
    margin-top: 25px;
    margin-left: 24px;
  `}
  ${smDown`
    margin: 16px 16px 30px;
    height: 100%;
    width: auto;
    background-color: rgba(255, 255, 255, 1);
    display: block;
    padding: 16px;
  `}
`;

export const StyledInfoWrapper = styled.div`
  width: 60%;
  ${lgDown`
    width: 45%;
  `}
  ${smDown`
    width: 100%;
`}
`;

export const StyledInfoTitle = styled.div`
  color: #003da5;
  font-family: Stag;
  font-size: 32px;
  font-weight: 500;
  line-height: 40px;
  padding-top: 48px;
  padding-left: 30px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  ${lgDown`
    font-size: 24px;
    padding-top: 24px;
    padding-left: 24px;
  `}
  ${smDown`
    font-size: 20px;
    line-height: 24px;
    padding: 0;
  `}
`;

export const StyledInfoSubTitle = styled.div`
  color: #0a1f44;
  font-family: Inter;
  font-size: 18px;
  line-height: 28px;
  padding-left: 30px;
  ${lgDown`
    padding-left: 24px;
  `}
  ${smDown`
    font-size: 16px;
    line-height: 20px;
    padding: 8px 0 16px;
  `}
`;

export const QnectButtonWraper = styled.div`
  padding-top: 54px;
  padding-right: 30px;
  flex-shrink:0;
  ${lgDown`
    padding-top: 25px;
    padding-right: 24px;
  `}
  ${smDown`
    padding: 0;
  `}
`;

export const StyledQnectButton = styled(QnectButton)`
  line-height: 28px;
  font-size: 20px;
  font-weight: 500;
  font-family: Inter;
  background-color: #1d4fbb;
  ${lgDown`
    box-shadow: none;
  `}
  ${smDown`
    height: 56px;
    line-height: 28px;
    font-size: 18px;
  `}
`;

export const AlertBar = styled.div`
    width: 100%;
    padding: 15px 30px;
    margin-top: 30px;
    color: #A50000;
    font-family: 'Inter', 'Inter Regular', sans-serif;
    font-size: 15px;
    display: flex;
    justify-content: center;
    & .info_alert_icon {
      width: 17px;
      height: 17px;
      margin-right: 13px
    }
    a {
      text-decoration: underline;
    }
    :hover {
        cursor: pointer;
    }
`;

export const StyledTitle = styled.div`
  color: #0a1f44;
  font-family: Stag;
  font-size: 24px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 28px;
  padding-top: 64px;
  ${lgDown`
    padding-top: 30px;
  `}
`;

export const StyledTitleRow = styled(StyledTitle)`
  display: flex;
  justify-content: space-between;
  ${lgDown`
    display: block;
  `}
`;

export const StyledItemWrapper = styled.div`
  display: flex;
`;

export const TableDiv = styled.div`
    margin-top: 36px;
    font-family: Inter-Semibold;
    font-size: 12px;
    box-shadow: 2px 2px 8px 0 rgba(20,40,75,0.2);
    border-radius: 10px;
    div.tableTitle {
        font-family: Inter-SemiBold;
        font-size: 16px;
        color: #0A1F44;
    }
    .MuiPaper-rounded {
        border-radius: 10px !important;
    }
    .MuiTableFooter-root .MuiToolbar-regular {
        border-bottom: 0;
    }
    .MuiToolbar-root {
        padding-right: 24px;
    }
`;

export const StyledPendingSwipeable = styled(SwipeableViews)`
  @media (max-width: 1279px) {
    padding: 0 800px 0 0;
  }
  @media (max-width: 1150px) {
    padding: 0 700px 0 0;
  }
  @media (max-width: 1080px) {
    padding: 0 600px 0 0;
  }
  @media (max-width: 959px) {
    padding: 0 500px 0 0;
  }
  @media (max-width: 849px) {
    padding: 0 400px 0 0;
  }
  @media (max-width: 759px) {
    padding: 0 300px 0 0;
  }
  @media (max-width: 650px) {
    padding: 0 200px 0 0;
  }
  @media (max-width: 550px) {
    padding: 0 100px 0 0;
  }
  @media (max-width: 450px) {
    padding: 0 100px 0 0;
  }
  @media (max-width: 450px) {
    padding: 0 20px 0 0;
  }
`;

export const StyledSwipeable = styled(StyledPendingSwipeable)`
  @media (max-width: 1279px) {
    padding: 0 700px 0 0;
  }
  @media (max-width: 1080px) {
    padding: 0 600px 0 0;
  }
  @media (max-width: 959px) {
    padding: 0 500px 0 0;
  }
  @media (max-width: 849px) {
    padding: 0 400px 0 0;
  }
  @media (max-width: 759px) {
    padding: 0 300px 0 0;
  }
  @media (max-width: 650px) {
    padding: 0 200px 0 0;
  }
  @media (max-width: 550px) {
    padding: 0 100px 0 0;
  }
  @media (max-width: 450px) {
    padding: 0 50px 0 0;
  }
  @media (max-width: 390px) {
    padding: 0 20px 0 0;
  }
`;

export const StyledNewsSwipeable = styled(SwipeableViews)`
  @media (max-width: 1279px) {
    padding: 0 700px 0 0;
  }
  @media (max-width: 1080px) {
    padding: 0 600px 0 0;
  }
  @media (max-width: 959px) {
    padding: 0 550px 0 0;
  }
  @media (max-width: 859px) {
    padding: 0 450px 0 0;
  }
  @media (max-width: 759px) {
    padding: 0 350px 0 0;
  }
  @media (max-width: 650px) {
    padding: 0 250px 0 0;
  }
  @media (max-width: 450px) {
    padding: 0 150px 0 0;
  }
`;

export const StyledLocatePolicyWrapper = styled(StyledItemWrapper)`
  cursor: pointer;
`;

export const StyledWhatsNewsTitle = styled(StyledTitle)`
  padding-top: 64px;
  ${lgDown`
    padding-top: 30px;
  `}
`;

export const StyledSectionWrapper = styled.div`
  width: 1110px;
  ${lgDown`
    width: 100%;
  `}
`;

export const StyledMessage = styled.div`
    margin-top: 38px;
    font-family: Inter-Regular;
    font-size: 16px;
    color: #0A1F44;
    @media (max-width:767.95px){
      margin-right: 16px;
    }
`;

const usePolicyStyles = makeStyles(theme => ({

    page_container: {
        marginTop: '15px',
        width: '1250px',
        marginLeft: 'auto',
        marginRight: 'auto',
        position: 'relative',
        [theme.breakpoints.between("1024", "1250")]: {
          width: '95%',
        },
        "& .MuiToolbar-regular" : {
          borderBottom: '1px solid #8A94A6',
          minHeight: '75px',
        },
        "& .MuiInputBase-root.MuiInput-formControl" : {
          minHeight: '42px',
          minWidth: '300px',
          padding: '8px 12px 8px 20px',
          border: '0',
          color: '#455571',
          fontFamily: 'Inter, Inter Regular, Inter-Regular, sans-serif',
          fontSize: '14px',
          lineHeight: '20px',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: '10px center',
          backgroundColor: '#F7F8F9',
          "& .MuiInputAdornment-positionEnd button" : {
            display: 'none',
          },
        },
        "& .MuiInputBase-root.MuiTablePagination-input" : {
          minHeight: '42px',
          border: '0',
          color: '#455571',
          fontFamily: 'Inter, Inter Regular, Inter-Regular, sans-serif',
          fontSize: '14px',
          lineHeight: '20px',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: '10px center',
        },
        "& .MuiInput-underline:hover:not(.Mui-disabled):before" : {
          borderBottom: '0',
        },
        "& .MuiInput-underline:before" : {
          borderBottom: '0',
        },
        "& .MuiInput-underline:after" : {
          borderBottom: '0',
        },
        "& .MuiTableBody-root" : {
          fontSize: '12px',
          "& .tableTitle" : {
            color: '#0A1F44',
          },
          "& td": {
            fontFamily: 'Inter Regular, Inter-Regular, Inter, sans-serif !important',
            fontSize: '400',
          },
        },
        "& .MuiTableCell-root" : {
          padding: '20px 16px',
        },
        "& .MuiTableFooter-root .MuiTablePagination-toolbar" : {
          minHeight: '75px',
        },
    },
    
    policy_container: {
        width: '1100px',
        margin: '0 auto',
    },

    policy_breadcrumb: {
      '& span' : {
          fontFamily: 'Inter, Inter Regular, Inter-Regular, sans-serif',
          fontSize: '12px',
          color: '#000',
          lineHeight: '18px',
          paddingBottom: '5px',
          borderBottom: '1px solid #E1E1E1',
          '& a' : {
              color: '#000',
          },
          '& a:hover' : {
              textDecoration: 'none',
          },
      },
    },
    breadcrumb_separator: {
      paddingLeft: '8px',
      paddingRight: '8px',
    },
    current_page: {
      fontWeight: 'bold',
      borderColor: '#000 !important',
    },

    policy_card_detail_container: {
      display: 'flex',
      flexWrap: 'wrap',
      marginTop: '60px',
      '& div:first-child' : {
        flexBasis: '50%',
      },
      '& div:nth-child(2)' : {
        flexBasis: '50%',
      }
    },
    policy_subsidiary_title: {
      fontFamily: 'Stag, sans-serif',
      color: '#0A1F44',
      fontSize: '36px',
      letterSpacing: '1px',
      fontWeight: '400'
    },
    submit_cancel_buttons: {
      display: 'flex',
      justifyContent: 'flex-end',
      '& button' : {
        borderRadius: '30px',
        border: '1px solid #002185',
        padding: '12px 25px',
        marginRight: '20px',
        fontFamily: 'Inter Medium, Inter-Medium, Inter, Inter-Regular, Inter Regular, sans-serif',
        fontSize: '14px',
        color: '#003DA5',
        lineHeight: '20px',
        background: '#fff',
      },
      '& button:last-child' : {
        marginRight: '0',
      }
    },
    submit_changes_button: {
      background: '#003DA5 !important',
      color: '#fff !important',
    },

    policy_card: {
      marginTop: '30px',
      flexBasis: '100%',
      borderRadius: '10px',
      boxShadow: '2px 2px 8px rgba(20,40,75,0.2)',
      padding: '30px 40px',
      border: '1px solid #E1E4E8',
      display: 'flex',
      flexWrap: 'wrap',
      '& div' : {
        flexBasis: '100%',
        display: 'flex'
      },
    },
    policy_number_details: {
      '& img' : {},
      '& div' : {
        marginLeft: '25px',
        flexDirection: 'column',
        '& span:first-child' : {
          marginBottom: '3px'
        },
        '& span:last-child' : {
          color: '#003DA5',
          fontFamily: 'Inter, Inter Regular, Inter-Regular, sans-serif',
          fontSize: '20px',
          lineHeight: '28px',
          fontWeight: '500'
        },
      },
    },

    policy_titles: {
      color: '#4D515B',
      fontFamily: 'Inter, Inter-Regular, Inter Regular, sans-serif',
      fontSize: '16px',
      lineHeight: '24px'
    },
  
    policy_date_status: {
      // display: 'none !important'
      display: 'block !important',
      '& .policy_status' : {
        fontFamily: 'Inter, Inter Regular, Inter-Regular, sans-serf',
        borderWidth: '1px',
        borderStyle: 'solid',
        fontSize: '12px',
        padding: '6px 10px',
        flexBasis: 'auto !important',
        borderRadius: '6px',
        marginTop: '5px',
        width: 'fit-content'
      },
      '& .status_active' : {
        borderColor: '#00C457',
        color: '#00C457',
        backgroundColor: 'rgba(0,196,86,0.008)',
      },
      '& .status_expiring_soon' : {
        borderColor: '#D43900',
        color: '#D43900',
        backgroundColor: 'rgba(212, 57, 0, 0.008)'
      },
      '& .status_inactive' : {
        borderColor: '#0A1F44',
        color: '#0A1F44',
        backgroundColor: 'rgba(241, 242, 244, 0.008)',
      }
    },
     policy_date: {
      color: '#000000',
      fontFamily: 'Inter, Inter Regular, Inter-Regular, sans-serif',
      fontSize: '20px',
      lineHeight: '28px',
      fontWeight: '500'
    },
    policy_details: {
      flexBasis: '100% !important',
      '& div' : {
        flexBasis: '33% !important',
      },
    },
    policy_premium: {
      // display: 'none !important'
      display: 'block !important'
    },
    policy_premium_price: {
      color: '#009AE4',
      fontFamily: 'Inter, Inter Regular, Inter-Regular, sans-serif',
      fontSize: '20px',
      lineHeight: '28px',
      fontWeight: '700'
    },
    policy_sub_premium_price: {
      color: '#4D515B',
      fontFamily: 'Inter, Inter Regular, Inter-Regular, sans-serif',
      fontSize: '16px',
      lineHeight: '24px',
      fontWeight: '400',
      marginTop: '4px'
    },

    subsidiary_plan_list_container: {
      display: 'flex',
      flexWrap: 'wrap',
      marginTop: '30px',
    },
    subsidiary_title: {
      fontFamily: 'Stag Medium, Stag-Medium, Stag, sans-serif',
      fontSize: '20px',
      lineHeight: '28px',
      letterSpacing: '1px',
      color: '#0A1F44',
      flexBasis: '100%'
    },
    subsidiary_listing_box: {
      marginTop: '25px',
      flexBasis: '100%',
      borderRadius: '10px',
      boxShadow: '2px 2px 8px rgba(20,40,75,0.2)',
      border: '1px solid #E1E4E8',
      marginBottom: '30px',
    },

    member_listing_container: {},
    member_listing_table: {
      width: '100%',
      '& th, td' : {
        padding: '25px 0',
        textAlign: 'left',
        fontSize: '12px',
        lineHeight: '18px',
        fontFamily: 'Inter, Inter Regular, Inter-Regular, sans-serif',
        color: '#0A1F44',
        margin: '0',
        borderBottom: '1px solid #E1E4E8',
      },
      '& th:last-child, td:last-child' : {
        paddingRight: '30px',
        width: '12%',
      },
      '& th:first-child, td:first-child' : {
        paddingLeft: '30px',
        width: '17%',
      },
      '& th:after' : {
        content: `url(${ArrowDownIcon})`,
        marginLeft: '15px',
      },
      '& .sort_desc:after' : {
        content: `url(${ArrowUpIcon})`,
      },
      '& th' : {
        fontFamily: 'Inter Semi-bold, Inter Semibold, Inter Semi Bold, Inter-Semi-Bold, Inter, sans-serif !important',
        textTransform: 'uppercase',
      },
      '& th:nth-child(2), td:nth-child(2)' : {
        width: '17%'
      },
      '& th:nth-child(3), td:nth-child(3)' : {
        width: '14%'
      },
      '& th:nth-child(4), td:nth-child(4)' : {
        width: '14%'
      },
      '& th:nth-child(5), td:nth-child(5)' : {
        width: '12%'
      },
      '& th:nth-child(6), td:nth-child(6)' : {
        width: '15%'
      },
      '& th:last-child:after' : {
        content: 'none !important',
      },
      '& td:last-child' : {
        textAlign: 'right',
      },
      '& td:last-child button' : {
        width: '16px',
        height: '16px',
        border: '0',
        backgroundColor: 'transparent',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center center',
        backgroundSize: 'cover',
      },
      '& td:first-child a' : {
        color: '#003DA5',
        textDecoration: 'none',
      },
      '& td.new_member a:before' : {
        content: `'*'`,
      },
    },

    edit_button: {
      backgroundImage: `url(${EditIcon})`,
      margin: '0 15px',
    },
    delete_button: {
      backgroundImage: `url(${DeleteIcon})`,
      margin: '0 0 0 15px',
    },
    
    new_member: {
      fontSize: '24px !important',
      '& a' : {
        color: 'red',
      },
    },

    table_footer: {
      display: 'flex',
      flexBasis: '100%',
      '& div:first-child' : {
        flexBasis: '40%',
      },
      '& div:nth-child(2)' : {
        flexBasis: '20%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },
      '& div:last-child' : {
        flexBasis: '40%',
      },
    },
    filter_options: {
      display: 'flex',
      alignItems: 'center',
      fontFamily: 'Inter Semi Bold, Inter Semi-bold, Inter-Semi-Bold, Inter, sans-serif',
      fontSize: '12px',
      lineHeight: '18px',
      color: '#717D92',
      padding: '28px 30px',
      '& div:first-child' : {
        flexBasis: 'unset',
        marginRight: '30px',
      },
      '& div:last-child' : {},
      '& div:last-child select' : {
        marginLeft: '10px',
        border: '0',
        color: '#455571',
        fontFamily: 'Inter Regular, Inter-Regular, Inter, sans-serif',
        padding: '5px',
      },
    },

    add_member: {
      minHeight: '52px',
      borderRadius: '50px',
      padding: '16px 27px',
      fontFamily: 'Inter Medium, Inter-Medium, Inter, sans-serif',
      fontSize: '14px',
      lineHeight: '20px',
      color: '#fff',
      textAlign: 'center',
      backgroundColor: '#003DA5',
      border: '1px solid #003DA5',
    },

    pagination_links: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      gap: '5px',
      flexBasis: 'unset',
      paddingRight: '30px',
      '& button' : {
        backgroundColor: 'transparent',
        border: '0',
      },
      '& a' : {
        display: 'flex',
        alignItems: 'center',
      },
      '& a button' : {
        color: '#455571',
        fontFamily: 'Inter Regular, Inter-Regular, Inter, sans-serif',
        fontSize: '12px',
        lineHeight: '18px',
      },
      '& a:active button, a:hover button' : {
        color: '#003DA5',
        fontWeight: 'bold',
      },
      '& button.paging_icon' : {
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center center',
        width: '10px',
        height: '10px',
      },
      '& button.paging_left_full' : {
        backgroundImage: `url(${PagingLeftFullIcon})`,
      },
      '& button.paging_left' : {
        backgroundImage: `url(${PagingLeftIcon})`,
      },
      '& button.paging_right_full' : {
        backgroundImage: `url(${PagingRightFullIcon})`,
      },
      '& button.paging_right' : {
        backgroundImage: `url(${PagingRightIcon})`,
      },
    },

    plan_member_changes_details: {
      textAlign: 'center',
      marginTop: '15px',
      width: '100%',
      fontFamily: 'Inter Regular, Inter-Regular, Inter, sans-serif',
      fontSize: '12px',
      color: '#717D92',
      '& span' : {
        color: '#003DA5',
        fontWeight: 'bold',
      }
    },

    legends_container: {
      marginBottom: '50px',
      width: '100%',
      fontFamily: 'Inter Regular, Inter-Regular, Inter, sans-serif',
      fontSize: '12px',
      color: '#717D92',
    },
    addMemberBtn: {
        position: 'absolute',
        right: 0
    },
    activeBreadcrumbLink: {
      fontFamily: 'Inter-SemiBold, Inter-Semi-bold, Inter Semi-bold, Inter Semibold, Inter Semi bold, Inter, sans-serif',
    }

}));

export default usePolicyStyles;